import React, { memo, useCallback } from "react";
import block from "bem-cn";

import Input from "components/Input";

import './InputRaw.scss'
import { useSelector } from "react-redux";

const b = block('input-item-desktop')

const normalizeInputValue = (value) => {
  if (value === null || value === undefined) return '';
  return String(value);
};

const DIGITS_ONLY_RE = /^\d*$/;

const InputRow = memo(({ inputKey, value, onChange }) => {
  const locale = useSelector((state) => state.locale.locale);

  const handleChange = useCallback(
    (e) => {
      const nextValue = e.currentTarget.value;

      if (DIGITS_ONLY_RE.test(nextValue)) onChange({ key: inputKey, value: nextValue })
    },
    [inputKey, onChange],
  );

  return (
    <div className={b()}>
      <p className={b('item-title')}>{locale[`${inputKey}Limits`]}</p>
      <Input
        value={normalizeInputValue(value)}
        onChange={handleChange}
        placeholder={locale[`${inputKey}LimitsPlaceholder`]}
        size="low"
        type="number"
      />
    </div>
  );
});

export default InputRow;